/**
 * Macintosh UA + multi-touch: an iPad on its default UA, or an iPhone in desktop mode.
 * The two are identical in shape, so only screen-size signals can tell them apart.
 */
export function isTouchMacUserAgent(rawUserAgent: string, maxTouchPoints = 0): boolean {
    const userAgent = rawUserAgent.toLowerCase();

    return (
        /macintosh|mac os x/.test(userAgent) &&
        !/iphone|ipod|ipad/.test(userAgent) &&
        maxTouchPoints > 1
    );
}

/**
 * Tablet named outright by the UA string alone — no client-side signals needed, so server and
 * client can share this rule.
 */
export function hasTabletUserAgentToken(rawUserAgent: string): boolean {
    return /ipad|tablet|playbook|silk|kindle|nexus (?:7|9|10)|android(?!.*mobile)/i.test(
        rawUserAgent,
    );
}

// maxTouchPoints distinguishes iPadOS desktop-mode Safari (Macintosh UA) from a real Mac when > 1.
export function isTabletUserAgent(rawUserAgent: string, maxTouchPoints = 0): boolean {
    return (
        isTouchMacUserAgent(rawUserAgent, maxTouchPoints) || hasTabletUserAgentToken(rawUserAgent)
    );
}
